/* eslint-disable */
export const getHeadersandRows = (data, productWiseMappingData, productList, selectedChildTab) => {
    const { mappingTypeValues } = data;
    const skuTypesString = selectedChildTab?.skuTypes || '';
    const allowedSkuTypes = skuTypesString.split(',').map(s => s.trim()).filter(Boolean);
    const defaultValue = selectedChildTab?.defaultValue;

    // 1. Filter Product List by SKU Type
    const filteredProductList = allowedSkuTypes.length > 0
        ? productList?.filter(p => allowedSkuTypes.includes(p.skuType))
        : productList;

    // 2. Identify Binary (YES/NO) Mappings
    const isBinaryMapping = mappingTypeValues?.length === 2 &&
        mappingTypeValues.some(m => m.displayName?.toUpperCase() === 'YES') &&
        mappingTypeValues.some(m => m.displayName?.toUpperCase() === 'NO');

    const yesOption = isBinaryMapping ? mappingTypeValues.find(m => m.displayName?.toUpperCase() === 'YES') : null;

    const headers = [{
        key: 'product',
        title: 'Product Name',
        customCol: true,
        fixed: true,
        width: 180,
    }];

    if (isBinaryMapping) {
        headers.push({
            key: 'consolidated_binary',
            title: selectedChildTab?.displayName || 'Status',
            id: 'consolidated',
            customCol: true,
            noPadding: true,
            sortable: true,
            width: 250,
            isYes: true,
        });
    } else {
        mappingTypeValues?.forEach((item) => {
            const displayName = item?.displayName?.toUpperCase();
            headers.push({
                key: String(item?.value),
                title: item?.displayName,
                id: item?.id,
                customCol: true,
                noPadding: true,
                sortable: true,
                width: 120,
                isYes: displayName === 'YES',
                isNo: displayName === 'NO'
            });
        });
    }

    if (!isBinaryMapping && headers?.length > 5) {
        headers?.forEach((header) => {
            if (header.key !== 'product') header.width = 120;
        });
    }

    // 3. Process existing mappings into a Map
    const mappingMap = new Map();
    productWiseMappingData?.forEach((mapping) => {
        const pid = mapping?.productId;
        if (!mappingMap.has(pid)) {
            mappingMap.set(pid, {
                mappingIds: [],
                details: mapping
            });
        }
        mappingMap.get(pid).mappingIds.push(String(mapping.mappingTypeElementValue));
    });

    // 4. Build Rows
    const rows = filteredProductList?.map((item) => {
        const productData = mappingMap.get(item?.id);
        let mappingIds = productData?.mappingIds || [];

        // Apply Default Value if no mapping exists at all
        if (mappingIds.length === 0 && defaultValue) {
            mappingIds = [String(defaultValue)];
        }

        const row = {
            ...item, // Keep all product fields (important for modal/saving)
            productName: item?.productName,
            mappingIds: mappingIds,
            ...(productData?.details || {}),
        };

        if (isBinaryMapping) {
            // For the row, we also store if it's considered 'Mapped' (Yes)
            row['is_yes_mapped'] = mappingIds.includes(String(yesOption?.value));
        }

        return row;
    }) || [];

    return { headers, rows };
};

export const mappingCategorized = {
    skuType: 'PRODUCT_TYPE',
    category: 'CATEGORY',
    subCategory: 'SUB_CATEGORY',
    product: 'PRODUCT',
};

export const skuTypes = [
    { id: 1, displayName: 'PRODUCT' },
    { id: 2, displayName: 'INTERMEDIATE' },
    { id: 3, displayName: 'INGREDIENT' },
    { id: 4, displayName: 'PACKAGING' },
    { id: 5, displayName: 'OTHER' },
    { id: 6, displayName: 'UNPACKED_PRODUCT' }
];

export const modalHeaders = [
    { label: 'SKU Type', color: '#475569' },
    { label: 'Category', color: '#ffb703' },
    { label: 'Sub Category', color: '#0d9488' },
    { label: 'Products', color: '#f97316' },
];

export const buildDrillDownTree = (params) => {
    const {
        categories,
        subCategories,
        productList,
        selectedMappingValue,
        list,
        productWiseMappingMap,
        selectedChildTab,
        isBinaryMapping
    } = params;

    const checkSelection = (type, nodeValue) => {
        const getMappingOn = mappingCategorized[type];
        const mappingData = list[getMappingOn];

        if (mappingData?.length > 0) {
            const isMapped = mappingData?.find((item) => String(item?.mappingOnElement) === String(nodeValue?.id));
            if (isMapped) {
                const isMappedData = productWiseMappingMap[isMapped?.id];
                const isMappedValue = isMappedData?.mappingTypeElementValue;

                const selectValue = isBinaryMapping
                    ? (isMappedValue ? parseInt(isMappedValue) === 1 ? 1 : -1 : -1)
                    : (String(isMappedValue) === String(selectedMappingValue?.value) ? 1 : -1);

                return { value: selectValue, isMappedData };
            }
        }

        if (selectedChildTab?.defaultValue) {
            const isDefaultMatch = String(selectedChildTab.defaultValue) === String(selectedMappingValue?.value);
            return { value: isDefaultMatch ? 1 : -1, isMappedData: null };
        }

        return { value: -1, isMappedData: null };
    };

    const skuTypesString = selectedChildTab?.skuTypes || '';
    const allowedSkuTypesList = skuTypesString.split(',').map(s => s.trim()).filter(Boolean);

    const filteredSkuTypes = allowedSkuTypesList.length > 0
        ? skuTypes.filter(s => allowedSkuTypesList.includes(s.displayName))
        : skuTypes;

    return filteredSkuTypes.map((skuType) => {
        const allowedProducts = productList?.filter((product) => product?.skuType === skuType?.displayName);
        const skuMapped = checkSelection('skuType', skuType);
        return {
            ...skuType,
            mappedData: skuMapped.isMappedData,
            name: skuType.displayName,
            type: "root",
            color: modalHeaders[0].color + '20',
            notRemove: 1,
            select: skuMapped.value,
            children: categories?.data?.map((category) => {
                const categoryMapped = checkSelection('category', category);
                return {
                    ...category,
                    mappedData: categoryMapped.isMappedData,
                    name: category.productCategoryName,
                    type: "category",
                    color: modalHeaders[1].color + '20',
                    notRemove: 0,
                    select: categoryMapped.value,
                    children: subCategories?.data?.filter((sub) => sub.categoryId === category.id)?.map((subCategory) => {
                        const subMapped = checkSelection('subCategory', subCategory);
                        return {
                            ...subCategory,
                            mappedData: subMapped.isMappedData,
                            name: subCategory.name,
                            type: "subCategory",
                            color: modalHeaders[2].color + '20',
                            notRemove: 0,
                            select: subMapped.value,
                            children: allowedProducts?.filter((p) => p.subCategoryId === subCategory.id)?.map((product) => {
                                const prodMapped = checkSelection('product', product);
                                return {
                                    ...product,
                                    mappedData: prodMapped.isMappedData,
                                    name: product.productName,
                                    type: "product",
                                    color: modalHeaders[3].color + '20',
                                    notRemove: 1,
                                    select: prodMapped.value,
                                };
                            }),
                        };
                    }),
                };
            }),
        };
    });
};
